import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { of, TimeoutError } from 'rxjs/index';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminAccountService } from '../../services/admin/admin-account.service';
import { selectAction } from '../../shared/state/index.state';
import {
    BsModalConfirmComponent,
    ConfirmDialogResult,
    createConfirmRetryModalOptions
} from '../modal/modal-confirm.component';
import { GatewayActions } from './gateway.actions';

/**
 * https://www.intertech.com/Blog/ngrx-tutorial-actions-reducers-and-effects/
 * https://medium.com/frontend-fun/angular-ngrx-a-clean-and-clear-introduction-4ed61c89c1fc
 */

@Injectable()
export class GatewayEffects {

    constructor(private actions$: Actions,
                private modalService: BsModalService,
                private adminAccountService: AdminAccountService) {
      // this.listenToRouter();
    }

    @Effect() getSharedNumbers$ = this.actions$
        .pipe(
            selectAction(GatewayActions.GET_SHARED_NUMBERS),
            map(action => action.payload),
            switchMap((userId: number) => // Switch to observe API response - and catch API error inside
                this.adminAccountService.getSharedNumbers(userId)
                    .pipe(
                        map((sharedNumbers: Array<any>) => GatewayActions.GET_SHARED_NUMBERS_SUCCESS(sharedNumbers)),
                        catchError(error => of(GatewayActions.GET_SHARED_NUMBERS_FAIL(error)))
                    ))
        );

    @Effect() getSharedNumbersFail$ = this.actions$
        .pipe(
            selectAction(GatewayActions.GET_SHARED_NUMBERS_FAIL),
            map(action => action.payload),
            switchMap(response => { // switch the pipe to observe closing the dialog

                let reason = '';

                if (response instanceof TimeoutError || response.name === 'TimeoutError') {
                    console.log(response);
                    reason += 'connection to server timed out';
                } else {
                    if (response.error.error !== undefined && response.error.error.reason) {
                        reason = ` (${response.error.error.reason})`;
                    }
                }
                const message = `Failed getting shared number due to server error${reason}. Would you like to try again?`;

                const modalRef = this.modalService
                    .show(BsModalConfirmComponent, createConfirmRetryModalOptions('Temporary Server Error', message));

                return modalRef.content.onClose;
            }),
            map((dialogResult: ConfirmDialogResult)  => { // map dialog result into action (map function returns observable to action)
                if (dialogResult.isConfirmed) {
                    return GatewayActions.GET_SHARED_NUMBERS;
                } else {
                    return {type: 'GET_SHARED_NUMBERS_FAIL_HANDLED'};
                }
            })
        );

}
